import type { HTMLAttributes } from "react";

import type { DefinedDefaults, TWithDataComponent } from "@/ui/lib";
import type {
  TInlineGapProp,
} from "@/ui/components/layout/Inline/Inline.config";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const FLEX_DIRECTION_CLASS_MAP = {
  row: "flex-row",
  column: "flex-col",
} as const;

export const FLEX_ALIGN_CLASS_MAP = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
} as const;

export const FLEX_JUSTIFY_CLASS_MAP = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TFlexDirection = keyof typeof FLEX_DIRECTION_CLASS_MAP;
export type TFlexAlign = keyof typeof FLEX_ALIGN_CLASS_MAP;
export type TFlexJustify = keyof typeof FLEX_JUSTIFY_CLASS_MAP;

export type TFlexProps = {
  direction?: TFlexDirection;
  align?: TFlexAlign;
  justify?: TFlexJustify;
  gap?: TInlineGapProp;
} & TWithDataComponent & HTMLAttributes<HTMLDivElement>;

type TFlexDefaultProps = DefinedDefaults<
  TFlexProps,
  "align" | "data-component" | "direction" | "gap" | "justify"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/


export const FLEX_DEFAULTS = {
  direction: "row",
  align: "stretch",
  justify: "start",
  gap: "none",
  "data-component": "Flex",
} satisfies TFlexDefaultProps;
